import React, { useState , useEffect} from "react";
import { Layout, Typography, Button, Row, Col, Space } from 'antd';
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import string from "../../constants/constants";
import { componentStyles } from "./EndingPageStyles";
import { useNavigate, useLocation } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { getScriptStatus } from "../../api/password";  
import { isNull } from "lodash";
import "./EndingPageStyle.css"
import { getRequest } from "../../api";


function EndingPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [gettingToKnowScriptStatus, setGettingToKnowScriptStatus] = useState(false);
  const [responseLoading, setResponseLoading] = useState(true);
  const location = useLocation();
  const botName = location.state;
  const [userId, setUserId] = useState(null); 
  const [avatar, setAvatar] = useState('');

  useEffect(() => {
    const storedUserId = localStorage.getItem("userid");
    setUserId(storedUserId);
  }, []);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  
  useEffect(() => {
    checkGettingToKnowYouScriptStatus();
  }, []);

  const checkGettingToKnowYouScriptStatus = async () => {
    try {
      const response = await getScriptStatus();
      if (!isNull(response.conversation)) {
        response?.conversationCompleted && setGettingToKnowScriptStatus(true);
        setResponseLoading(true);
      } else {
        setGettingToKnowScriptStatus(false);
        setResponseLoading(true);
      }
    } catch (err) {
      console.log("In catch", err);
    }
  };

  const { Content } = Layout;
  const { Text } = Typography;

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const navigate = useNavigate();

  const fetchAvatar = async () => {
    try {
      const response = await getRequest('/user/get-avatar');

      if (response.error) {
        console.error("Error fetching avatar:", response.error);
      } else {
        const avatar = response.avatar;
        if (avatar === 'Amy' || avatar === 'Arthur' || avatar === 'Sam') {
          setAvatar(avatar);
        } else {
        }
      }
    } catch (error) {
      console.error("Error fetching avatar:", error);
    }
  };

  useEffect(() => {
    fetchAvatar();
  }, []);

  const handleConversationButtonClick = () => {
    if (avatar === 'Sam') {
      gettingToKnowScriptStatus
      ? navigate("/text-conversation?type=openConversation", { state: { userId: userId } })
      : navigate("/text-conversation?type=gettingToKnowYou", { state: { userId: userId } });
    } else {
      gettingToKnowScriptStatus
      ? navigate("/conversation?type=openConversation", {state: {userId: userId}})
      : navigate("/conversation?type=gettingToKnowYou", {state: {userId: userId}});
    }
  };

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  return (
    <div style={{minHeight: "100dvh" , overflow: "hidden"}} className="setEndBackground">
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={componentStyles.spacingBottom}
        >
          <Col xs={22} lg={24} md={22}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col xs={4} lg={4} md={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>
        <Content className="content">
          <Row justify="left" align="" className="main-row">
            <Col span={24} className="text-col">
              <h1 style={componentStyles.titleStyle}>
                {`We hope you enjoyed talking with ${botName.botName}!`}
              </h1>
              <Text className="text-para-style">
                Your conversation has automatically been saved to your profile. Click the top right corner to view this at any time. 
                You can also choose to download or print a conversation to save it in multiple different formats.
              </Text>
              <br />
              <Space className="buttons">
                <Button onClick={handleConversationButtonClick} style={componentStyles.button3} >Start a new Conversation</Button>
                <RouterLink
                  to="/landing-page"
                  style={{ textDecoration: "none" }}
                >
                  <Button style={componentStyles.button2}>
                    {string.returnToHome}
                  </Button>
                </RouterLink> 
              </Space> 
            </Col>
          </Row>
        </Content> 
      </Col>
    </div>
  );
}

export default EndingPage;
